<template>
  <div>
    <!-- <div>{{ title }}</div> -->
    <div class="flex flex-row">
      <slot />
    </div>
  </div>
</template>
<script>

export default {
  props: ['title'],
};
</script>
